import React, { Component } from 'react';
import { addressApi } from '../../api/Api';
import { NotificationContainer, NotificationManager } from 'react-notifications';

import { Link } from 'react-router-dom';
import AccountMenu from './AccountMenu';

import AddressNew from './AddressNew';
import AddressList from './AddressList';
import AddressModal from './AddressModal';
import './AddressTheme.css';

class Address extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addressList:[],
            showNewAddressBox:false,
            editingAddress:null,
            serviceCheck:false,
            defaultUpdatingId:null,
            deletingId:null,
            deleteCandidate:null,
            addressSaving:false,
        }   
        this.showNewAddressBox = this.showNewAddressBox.bind(this);
        this.handleEditAddress = this.handleEditAddress.bind(this);
        this.refreshAddresses = this.refreshAddresses.bind(this);
    }

    componentDidMount() {
        this.refreshAddresses();
    }

    getAddressesFromResponse(responseData) {
        const data = responseData && responseData.data ? responseData.data : responseData;

        if (Array.isArray(data)) {
            return data;
        }

        if (!data) {
            return [];
        }

        return data.addresses || data.items || data.records || data.data || [];
    }

    normalizeAddress(address) {
        const addressType = address.user_address_type || address.address_type || '';

        return {
            ...address,
            address_id: address.address_id || address.id,
            user_name: address.user_name || address.name || '',
            user_mobile: address.user_mobile || address.mobile || '',
            user_pincode: address.user_pincode || address.postal_code || '',
            user_locality: address.user_locality || address.locality || address.address_line_2 || '',
            user_address: address.user_address || address.address_line_1 || '',
            user_city: address.user_city || address.city || '',
            user_state: address.user_state || address.state || '',
            user_landmark: address.user_landmark || address.landmark || '',
            user_address_type: addressType === 'Home' ? 'H' : addressType === 'Work' ? 'W' : addressType,
        };
    }

    async refreshAddresses() {
        this.setState({ serviceCheck: false });
        try {
            const response = await addressApi.list();
            let resVal = response.data;
            const addresses = this.getAddressesFromResponse(resVal);
            if (Array.isArray(addresses)) {
                this.setState({ addressList: addresses.map((address) => this.normalizeAddress(address)), serviceCheck: true });
            } else {
                this.setState({ serviceCheck: true });
            }
        } catch (error) {
            console.error(error);
            this.setState({ serviceCheck: true });
        }
    }

    async makeDefaultAddress(address) {
        const addressId = address && (address.address_id || address.id);
        if (!addressId || this.state.defaultUpdatingId) return;

        this.setState({ defaultUpdatingId: addressId });
        try {
            const response = await addressApi.setDefault(addressId);
            const payload = response.data || {};
            if (payload.status === 'success') {
                NotificationManager.success(payload.message || 'Default address updated.');
                await this.refreshAddresses();
            } else {
                NotificationManager.error(payload.message || 'Unable to update default address.');
            }
        } catch (error) {
            NotificationManager.error(error.response?.data?.message || 'Unable to update default address.');
        } finally {
            this.setState({ defaultUpdatingId: null });
        }
    }

    async deleteAddress(address) {
        const addressId = address && (address.address_id || address.id);
        if (!addressId || this.state.deletingId) return;

        this.setState({ deletingId: addressId });
        try {
            const response = await addressApi.delete(addressId);
            const payload = response.data || {};
            if (payload.status === 'success') {
                NotificationManager.success(payload.message || 'Address deleted successfully.');
                await this.refreshAddresses();
            } else {
                NotificationManager.error(payload.message || 'Unable to delete address.');
            }
        } catch (error) {
            NotificationManager.error(error.response?.data?.message || 'Unable to delete address.');
        } finally {
            this.setState({ deletingId: null });
        }
    }

    requestDeleteAddress(address) {
        if (this.state.deletingId) return;
        this.setState({ deleteCandidate: address });
    }

    confirmDeleteAddress = async () => {
        const address = this.state.deleteCandidate;
        this.setState({ deleteCandidate: null });
        if (address) await this.deleteAddress(address);
    };

    showNewAddressBox(passVal){
        this.setState({showNewAddressBox:passVal});
        if(passVal===false){
            this.setState({editingAddress:null});
        }
    }

    handleEditAddress(address){
        this.setState({
            editingAddress: address,
            showNewAddressBox: true,
        });
    }

    loadAddNewAddress(){
        if(this.state.showNewAddressBox===true){
            return(
                    <AddressNew
                        key={this.state.editingAddress ? this.state.editingAddress.address_id : 'new-address'}
                        showNewAddressBox={this.showNewAddressBox}
                        onSaved={this.refreshAddresses}
                        initialAddress={this.state.editingAddress}
                        onSavingChange={(addressSaving) => this.setState({addressSaving})}
                    />
            )
        }else{
            return null;
        }
    }

    render() {
        return (
            <div className="ps-account-page ps-account-page--profile nw-account nw-address">
                <div className="ps-categogy ps-categogy--separate ps-account-shell">
                    <div className="container whiteContainer ps-account-shell__container">
                        <div className="ps-account-shell__layout">
                            <AccountMenu {...this.props}/>

                            <main className="ps-account-shell__content">
                                <div className="ps-account-shell__topbar">
                                    <nav aria-label="Breadcrumb"><ul className="ps-breadcrumb ps-account-shell__breadcrumb">
                                        <li className="ps-breadcrumb__item"><Link to="/">Home</Link></li>
                                        <li className="ps-breadcrumb__item"><Link to="/account">My account</Link></li>
                                        <li className="ps-breadcrumb__item active" aria-current="page">Manage addresses</li>
                                    </ul></nav>
                                </div>

                                <section className="ps-account-shell__hero">
                                    <div className="ps-account-shell__heroCopy">
                                        <div>
                                            <h1>My <span>addresses</span></h1>
                                            <p>Your saved places, ready for your next delivery.</p>
                                        </div>
                                        <button type="button" className="nw-account__button nw-address__add" onClick={() => this.setState({editingAddress:null, showNewAddressBox:true})}>
                                            <span aria-hidden="true">+</span> Add new address
                                        </button>
                                    </div>
                                </section>

                                <section className="ps-account-shell__panel">
                                    <div className="nw-address__saved">
                                        <div className="nw-address__list-heading">
                                            <h2>Saved addresses</h2>
                                            {this.state.serviceCheck && <span>{this.state.addressList.length} saved</span>}
                                        </div>

                        <AddressList
                            addressList={this.state.addressList}
                            loading={!this.state.serviceCheck}
                            defaultUpdatingId={this.state.defaultUpdatingId}
                            deletingId={this.state.deletingId}
                            onEditAddress={this.handleEditAddress}
                            onSetDefault={(address) => this.makeDefaultAddress(address)}
                            onDeleteAddress={(address) => this.requestDeleteAddress(address)}
                        />
                                    </div>
                                </section>
                            </main>
                        </div>
                    </div>
                </div>
                {this.state.showNewAddressBox && <AddressModal
                    title={this.state.editingAddress ? 'Edit address' : 'Add new address'}
                    busy={this.state.addressSaving}
                    onClose={() => this.showNewAddressBox(false)}
                >{this.loadAddNewAddress()}</AddressModal>}
                {this.state.deleteCandidate ? (
                    <div className="ps-address-confirm" role="dialog" aria-modal="true" aria-labelledby="deleteAddressTitle">
                        <button
                            type="button"
                            className="ps-address-confirm__backdrop"
                            aria-label="Close confirmation"
                            onClick={() => this.setState({ deleteCandidate: null })}
                        />
                        <div className="ps-address-confirm__dialog">
                            <div className="ps-address-confirm__icon" aria-hidden="true">!</div>
                            <h2 id="deleteAddressTitle">Delete this address?</h2>
                            <p>
                                This will remove <strong>{this.state.deleteCandidate.user_name || this.state.deleteCandidate.name || 'this saved address'}</strong> from your delivery addresses.
                            </p>
                            <div className="ps-address-confirm__actions">
                                <button type="button" className="ps-address-confirm__cancel" onClick={() => this.setState({ deleteCandidate: null })}>Keep address</button>
                                <button type="button" className="ps-address-confirm__delete" onClick={this.confirmDeleteAddress}>Delete address</button>
                            </div>
                        </div>
                    </div>
                ) : null}
                <NotificationContainer/>
            </div>
        );
    }
}

export default Address;
